import BaseService from 'services/BaseService';

class TradingVenuesService extends BaseService {
  getList() {
    return this.get('/api/tradingVenuesList');
  }

  getSubscriptionList() {
    return this.get('/api/subscription/info');
  }

  getSubscriptionPrice(venues) {
    return this.post('/api/subscription/changePrice', {
      venueList: venues
    });
  }

  updateSubsriptions(venues) {
    return this.post('/api/subscription/changeSubscription', {
      venueList: venues
    });
  }

  cancelPayment(orderId) {
    return this.post('/api/payment/cancel', { OrderID: orderId });
  }
}

export default TradingVenuesService;



// WEBPACK FOOTER //
// ./src/services/TradingVenuesService.js